<template>
  <SPASearchbar v-model.trim="localDrawerSearch" @keydown.enter.stop="handleSearch" @clickSearch="handleSearch" placeholder="Search" />
</template>

<script>
import { storeToRefs } from 'pinia';
import { ref } from 'vue';
import SPASearchbar from '../../../../components/SPASearchbar.vue';
import { checkBlankSpace } from '../../../../helpers/inputValidator';
import { useProjectTaggingStore } from '../../../../stores/projectTagging';

export default {
  components: {
    SPASearchbar,
  },
  setup() {
    const projectTagging = useProjectTaggingStore();
    const { drawerSearch, localSelectedDrawerFilter, selectedDrawerFilter, drawerPagination } = storeToRefs(projectTagging);
    const localDrawerSearch = ref('');
    const handleSearch = async () => {
      drawerSearch.value = localDrawerSearch.value;
      selectedDrawerFilter.value = localSelectedDrawerFilter.value;
      const params = {
        SearchString: drawerSearch.value,
        FilterBy: !checkBlankSpace(selectedDrawerFilter.value) ? selectedDrawerFilter.value : 'LastName',
      };

      if (!checkBlankSpace(drawerSearch.value)) {
        projectTagging.getEmployeeLookup(params);
      } else {
        projectTagging.getEmployeeLookup({
          PageNumber: drawerPagination.value.currentPage,
        });
      }
    };
    return {
      drawerSearch,
      handleSearch,
      localDrawerSearch,
    };
  },
};
</script>
